import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const STATUS = {
  pending: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  approved: 'bg-green-500/20 text-green-400 border-green-500/30',
  rejected: 'bg-red-500/20 text-red-400 border-red-500/30',
};

/** The user's own hours change requests and their outcomes. */
export const MyHoursRequestsCard = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/portal/hours/change-requests?limit=10').then(r => setItems(r.data || [])).catch(() => setItems([])); }, [api]);
  if (!items || items.length === 0) return null;
  return (
    <Card className="bg-[#2A3240] border-white/10" data-testid="profile-hours-requests">
      <CardHeader className="pb-3"><CardTitle className="text-white text-lg flex items-center gap-2"><Clock className="w-5 h-5 text-[#F5A623]" /> Hours change requests</CardTitle></CardHeader>
      <CardContent className="space-y-2">
        {items.map(r => (
          <button key={r.id} type="button" onClick={() => navigate(`/portal/job/${r.project_id}?date=${r.date}`)} className="w-full text-left rounded-xl bg-[#1E2530] p-3 active:scale-[0.99]" data-testid={`profile-hours-request-${r.id}`}>
            <div className="flex items-center gap-2">
              <span className="text-[#F5A623] text-sm font-semibold">{r.project_ref || 'Job'}</span>
              <span className="text-gray-400 text-xs">{format(parseISO(r.date), 'EEE d MMM')}</span>
              <Badge className={`ml-auto ${STATUS[r.status] || ''}`}>{r.status}</Badge>
            </div>
            <p className="text-white text-sm mt-1"><span className="text-gray-500 line-through mr-2">{r.current_hours != null ? `${r.current_hours}h` : '—'}</span>{r.requested_hours}h</p>
            {r.review_note && <p className="text-xs text-gray-400 mt-1">Office: {r.review_note}</p>}
          </button>
        ))}
      </CardContent>
    </Card>
  );
};
